"use strict";

exports.__esModule = true;
exports.downloadOptionPropType = exports["default"] = exports.DownloadIcon = exports.ButtonCta = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../../components/glyphs/elements");

var _cta = _interopRequireDefault(require("../../components/cta"));

var _excluded = ["external", "id", "optionOnClick", "text"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DownloadIcon = (0, _styledComponents["default"])(_elements.NavDownload).withConfig({
  displayName: "download-link__DownloadIcon",
  componentId: "sc-1p949wl-0"
})(["margin-left:8px;width:18px;height:18px;fill:currentColor;vertical-align:text-bottom;"]);
exports.DownloadIcon = DownloadIcon;
var ButtonCta = (0, _styledComponents["default"])(_cta["default"]).withConfig({
  displayName: "download-link__ButtonCta",
  componentId: "sc-1p949wl-1"
})(["display:inline-block;white-space:nowrap;"]);
exports.ButtonCta = ButtonCta;
var downloadOptionPropType = {
  /** if download option has external link */
  external: _propTypes.bool,

  /** id of option */
  id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,

  /** onClick handler for download option, defaults to downloadAction */
  optionOnClick: _propTypes.func,

  /** download option text */
  text: _propTypes.string
};
exports.downloadOptionPropType = downloadOptionPropType;

var DownloadLink = function DownloadLink(_ref) {
  var external = _ref.external,
      id = _ref.id,
      optionOnClick = _ref.optionOnClick,
      text = _ref.text,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, null, /*#__PURE__*/_react["default"].createElement(ButtonCta, {
    key: id,
    fontSize: 2,
    fontWeight: 2,
    id: id,
    letterSpacing: "0.5px",
    mb: 0,
    mr: 3,
    onClick: function onClick(event) {
      return optionOnClick({
        data: props,
        event: event
      });
    },
    version: "link"
  }, text, /*#__PURE__*/_react["default"].createElement(DownloadIcon, null))));
};

DownloadLink.propTypes = downloadOptionPropType;
var _default = DownloadLink;
exports["default"] = _default;